export enum DashboardCursorSync {
  Off,
  Crosshair,
  Tooltip,
}
